/* bios-glitch-popups.js — fake infected-system error dialogs.
   Periodic kernel/process/intrusion-style popups scattered around the
   viewport viewport edges (never dead-center, never overlapping content
   for long). Pure decoration — no behavior beyond the typewriter +
   fade lifecycle. Mobile gets a sparser cadence (MAX_ACTIVE=1, longer
   intervals) so the popups don't crowd the small screen. */
(function initGlitchPopups() {
  'use strict';

  var layer = document.getElementById('bios-glitch-layer');
  if (!layer) return;

  var POOL = [
    /* Kernel / system errors */
    { type:'err',  lines:['KERNEL: BUG: unable to handle page fault','IP: 0xffffffff81a4c3e2  PGD 0','Oops: 0000 [#1] SMP NOPTI'] },
    { type:'err',  lines:['segfault at 7fff0000 ip 00007f8a34c1 sp 00007fff','error 4 in libc-2.31.so[7f8a340000+]'] },
    { type:'err',  lines:['[drm:amdgpu_job_timedout] *ERROR* ring gfx_0.0.0 timeout','ERROR: process_info: no such process (PID 3841)'] },
    { type:'err',  lines:['EXT4-fs error (device sda1): ext4_validate_block_bitmap:376','corrupt block bitmap - block_group = 14, block = 917504'] },
    { type:'warn', lines:['WARNING: CPU: 0 PID: 1 at mm/memory.c:3512','possible memory corruption at 0x00007f3b2c000000','WARN_ON(PageSwapBacked(page))'] },
    { type:'warn', lines:['audit: type=1701 audit(1714000000.381:298):','auid=0 uid=0 gid=0 ses=1','comm="catalog" exe="/usr/bin/catalog"'] },
    { type:'warn', lines:['net_ratelimit: 12 callbacks suppressed','TCP: out of memory -- consider tuning tcp_mem','dropping connection from 192.168.1.1'] },
    /* Process / exec output */
    { type:'cmd',  lines:['root@innocences:~# ps aux | grep defunct','www-data  3841  99.9  0.0  zombie','root@innocences:~# kill -9 3841'] },
    { type:'cmd',  lines:['root@innocences:~# netstat -antp | grep ESTABLISHED','tcp  0.0.0.0:443  ESTABLISHED  3841/node','tcp  0.0.0.0:22   TIME_WAIT   2918/sshd'] },
    { type:'cmd',  lines:['root@innocences:~# find / -name "*.key" 2>/dev/null','find: permission denied: /proc/tty','find: permission denied: /sys/kernel/security'] },
    { type:'cmd',  lines:['root@innocences:~# dmesg | tail -3','[38924.441] usb 1-1: USB disconnect, device number 3','[38924.889] ata1.00: exception Emask 0x10','[38924.889] ata1.00: irq_stat 0x00400040'] },
    { type:'cmd',  lines:['root@innocences:~# cat /proc/meminfo | grep -i dirty','Dirty:          288512 kB','Writeback:        4096 kB'] },
    { type:'cmd',  lines:['root@innocences:~# strace -p 3841','strace: attach: ptrace(PTRACE_SEIZE, 3841): No such process','root@innocences:~# ▌'] },
    /* Cryptic intrusion-style */
    { type:'err',  lines:['INTRUSION DETECTED — PAYLOAD: /tmp/.x86_64.elf','SHA256: a3f1c9e2b8d047...  [UNKNOWN SIGNATURE]','isolation: FAILED — process still running'] },
    { type:'warn', lines:['[WATCHDOG] process "catalog" exceeded mem limit','RSS: 2.1G / 512M limit','SIGKILL dispatched — respawning...'] },
    { type:'err',  lines:['CRON[4012]: (root) CMD: /tmp/.update 2>/dev/null','CRON: permission denied — path not in $CRON_ALLOW','audit: suspicious cron entry flagged'] },
    { type:'cmd',  lines:['root@innocences:~# ss -tulpn','Netid  State   Local Address    Process','tcp    LISTEN  0.0.0.0:4444     users:("nc",pid=9182)'] },
    { type:'warn', lines:['[4503.331] possible RCE via CVE-2024-1086','affected: kernel 6.1.x < 6.1.76','mitigation: UNAVAILABLE on this build'] },
  ];

  var active = 0;
  var MAX_ACTIVE = 3;

  /* ── Exclusion zones — popups must not overlay these elements.
     Read at spawn time so we get current layout (responsive). */
  function rectOf(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    return r;
  }
  function rectsIntersect(a, b) {
    return a.right > b.left && a.left < b.right && a.bottom > b.top && a.top < b.bottom;
  }
  function getExclusions() {
    return [
      rectOf('.bios-header'),       /* top status bar */
      rectOf('.bios-footer'),       /* prompt / search bar */
      rectOf('.bios-manifest'),     /* CPU / UPLINK / DROP / etc. */
      rectOf('.bios-top-right'),    /* music player + clock */
      rectOf('.bios-list-hdr'),     /* [NEW ARRIVALS] heading */
      rectOf('#bios-list'),         /* product names column */
      rectOf('#bios-netfield'),     /* photo grid (right side) */
      rectOf('#bios-logstream')     /* ambient syslog */
    ].filter(Boolean);
  }

  function spawnPopup() {
    if (active >= MAX_ACTIVE) return;

    var entry = POOL[Math.floor(Math.random() * POOL.length)];
    var el    = document.createElement('div');
    el.className = 'bios-glitch-popup bios-glitch-' + entry.type;

    /* Position: pick a candidate, check it doesn't overlap the item
       nodes, product names, header, footer, music UI, manifest, or
       NEW ARRIVALS heading. Up to 12 attempts; if none work, drop
       this spawn (popup is decorative — silently skipping is fine). */
    var W = window.innerWidth, H = window.innerHeight;
    var maxW   = Math.min(300, W * 0.32);
    /* Estimated popup height with 2-4 lines of typewriter text +
       padding. Used for collision rect. */
    var popH   = 160;
    var excl   = getExclusions();
    var left = -1, top = -1;
    for (var attempt = 0; attempt < 12; attempt++) {
      var l = 14 + Math.random() * (W - maxW - 28);
      var t = 70 + Math.random() * (H - popH - 140);
      var cand = { left: l, top: t, right: l + maxW, bottom: t + popH };
      var safe = true;
      for (var ei = 0; ei < excl.length; ei++) {
        if (rectsIntersect(cand, excl[ei])) { safe = false; break; }
      }
      if (safe) { left = l; top = t; break; }
    }
    if (left < 0) return; /* no safe spot this cycle — skip */

    el.style.cssText = 'left:' + Math.round(left) + 'px;top:' + Math.round(top) + 'px;max-width:' + maxW + 'px';
    layer.appendChild(el);
    active++;

    /* Typewriter reveal line by line */
    var lineIdx = 0;
    function nextLine() {
      if (lineIdx >= entry.lines.length) {
        /* Hold then fade out */
        el.classList.add('bios-glitch-visible');
        var hold = 3500 + Math.random() * 4000;
        setTimeout(function() {
          el.classList.remove('bios-glitch-visible');
          setTimeout(function() { el.remove(); active = Math.max(0, active - 1); }, 350);
        }, hold);
        return;
      }
      var lineEl = document.createElement('div');
      lineEl.className = 'bios-glitch-line';
      el.appendChild(lineEl);
      el.classList.add('bios-glitch-visible');
      var txt = entry.lines[lineIdx++], ci = 0;
      (function ch() {
        if (ci < txt.length) {
          lineEl.textContent = txt.slice(0, ++ci);
          setTimeout(ch, 8 + Math.random() * 14);
        } else {
          setTimeout(nextLine, 60 + Math.random() * 120);
        }
      })();
    }
    nextLine();
  }

  /* Desktop: full frequency. Mobile: sparse, max 1 popup at a time.
     isTouchDevice is set by bios-main.js as a window global. */
  if (!window.isTouchDevice) {
    setTimeout(spawnPopup,  4000 + Math.random() * 6000);
    setTimeout(spawnPopup, 10000 + Math.random() * 8000);
    setInterval(function() {
      if (Math.random() < 0.65) spawnPopup();
    }, 12000 + Math.random() * 6000);
  } else {
    MAX_ACTIVE = 1; /* only ever 1 popup at a time on mobile */
    setTimeout(spawnPopup, 12000 + Math.random() * 18000);
    setInterval(function() {
      if (Math.random() < 0.4) spawnPopup();
    }, 30000 + Math.random() * 20000);
  }
})();
